/*
 * File Created: Thursday, 11th May 2023 8:23:59 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import React from "react";
import Cart from "../components/cart/Cart";

function Order() {
  // const theme: Theme = useTheme();
  React.useEffect(() => {
    window.scrollTo(0,0);
  }, [])
  return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Cart />
      </Box>
  );
}

export default Order;
